import React, { useState, useEffect } from "react";
import "./HeroSection.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faCoffee,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";

import herotext from "../assets/images/banner-text.png";
import BannerLogo from "../assets/images/banner-logo.png";
import ToolsLeft from "../assets/images/tools-left.png";
import ToolsRight from "../assets/images/tools-right.png";
import BrochureDownload from "../assets/images/brochure-download.png";
import bannerImg1 from '../assets/images/banner-img01.png';
import bannerImg2 from '../assets/images/banner-img02.png';
import bannerImg3 from '../assets/images/banner-img03.png';
import bannerImg4 from '../assets/images/banner-img04.png';
import bannerImg5 from '../assets/images/banner-img05.png';
import Navbar from "./Navbar";

// ========== NAYA SLIDER COMPONENT ==========
const ImageSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(2);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  const images = [
    { id: 1, bg: bannerImg1, label: '', className: 'slider-card-1' },
    { id: 2, bg: bannerImg2, label: '', className: 'slider-card-2' },
    { id: 3, bg: bannerImg3, label: '', className: 'slider-card-3' },
    { id: 4, bg: bannerImg4, label: '', className: 'slider-card-4' },
     { id: 5, bg: bannerImg5, label: '', className: 'slider-card-5' },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleImageClick = (index) => {
    setCurrentIndex(index);
  };

  // Responsive values
  const isMobile = windowWidth <= 1250;
  const isTablet = windowWidth > 768 && windowWidth <= 1250;
  
  const cardWidth = isMobile ? 280 : isTablet ? 340 : 402;
  const cardHeight = isMobile ? 195 : isTablet ? 237 : 280;
  const marginTop = isMobile ? '80px' : isTablet ? '150px' : '220px';
  const perspective = isMobile ? '800px' : isTablet ? '1200px' : '1500px';

  return (
   <div className="main-image-slider" style={{
      width: '100%',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: marginTop,
      perspective: perspective,
      overflow: 'visible',
    }}>
      <div className="image-slider" style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        {images.map((img, index) => {
          const diff = (index - currentIndex + images.length) % images.length;
          let transform = '';
          let zIndex = 1;
          let opacity = 0.4;
          const isEvenIndex = index % 2 === 0;

          if (isMobile) {
            // Mobile: Only show center card prominently, side cards barely visible
            if (diff === 0) {
              const tilt = isEvenIndex ? -3 : 3;
              transform = `translateX(0px) translateZ(0px) rotateY(0deg) rotateZ(${tilt}deg) scale(1)`;
              zIndex = 97;
              opacity = 1;
            } else if (diff === 1) {
              const tilt = isEvenIndex ? -3 : 3;
              transform = `translateX(180px) translateZ(-100px) rotateY(-25deg) rotateZ(${tilt}deg) scale(0.75)`;
              zIndex = 96;
              opacity = 1;
            } else if (diff === images.length - 1) {
              const tilt = isEvenIndex ? 3 : -3;
              transform = `translateX(-180px) translateZ(-100px) rotateY(25deg) rotateZ(${tilt}deg) scale(0.75)`;
              zIndex = 90;
              opacity = 1;
            } else {
              transform = 'translateX(0px) translateZ(-500px) scale(0.3)';
              zIndex = 1;
              opacity = 1;
            }
          } else if (isTablet) {
            // Tablet: Show 3 cards clearly
            if (diff === 0) {
              const tilt = isEvenIndex ? -3 : 3;
              transform = `translateX(0px) translateZ(0px) rotateY(0deg) rotateZ(${tilt}deg) scale(1)`;
              zIndex = 97;
              opacity = 1;
            } else if (diff === 1) {
              const tilt = isEvenIndex ? -4 : 4;
              transform = `translateX(230px) translateZ(-130px) rotateY(-30deg) rotateZ(${tilt}deg) scale(0.8)`;
              zIndex = 96;
              opacity = 1;
            } else if (diff === 2) {
              const tilt = isEvenIndex ? -4 : 4;
              transform = `translateX(400px) translateZ(-220px) rotateY(-40deg) rotateZ(${tilt}deg) scale(0.65)`;
              zIndex = 95;
              opacity = 1;
            } else if (diff === images.length - 1) {
              const tilt = isEvenIndex ? 4 : -4;
              transform = `translateX(-230px) translateZ(-130px) rotateY(30deg) rotateZ(${tilt}deg) scale(0.8)`;
              zIndex = 90;
              opacity = 1;
            } else if (diff === images.length - 2) {
              const tilt = isEvenIndex ? 4 : -4;
              transform = `translateX(-400px) translateZ(-220px) rotateY(40deg) rotateZ(${tilt}deg) scale(0.65)`;
              zIndex = 80;
              opacity = 1;
            }
          } else {
            // Desktop: Original full carousel

            if (diff === 0) {
              const tilt = isEvenIndex ? -3 : 3;
              transform = `translateX(0px) translateZ(0px) rotateY(0deg) rotateZ(${tilt}deg) scale(1)`;
              zIndex = 97;
              opacity = 1;
            } else if (diff === 1) {
              const tilt = isEvenIndex ? -5 : 5;
              transform = `translateX(300px) translateZ(-180px) rotateY(-35deg) rotateZ(${tilt}deg) scale(0.85)`;
              zIndex = 96;
              opacity = 1;
            } else if (diff === 2) {
              const tilt = isEvenIndex ? -5 : 5;
              transform = `translateX(500px) translateZ(-300px) rotateY(-45deg) rotateZ(${tilt}deg) scale(0.7)`;
              zIndex = 95;
              opacity = 1;
            } else if (diff === images.length - 1) {
              const tilt = isEvenIndex ? 5 : -5;
              transform = `translateX(-300px) translateZ(-180px) rotateY(35deg) rotateZ(${tilt}deg) scale(0.85)`;
              zIndex = 90;
              opacity = 1;
            } else if (diff === images.length - 2) {
              const tilt = isEvenIndex ? 5 : -5;
              transform = `translateX(-500px) translateZ(-300px) rotateY(45deg) rotateZ(${tilt}deg) scale(0.7)`;
              zIndex = 80;
              opacity = 1;
            }
          }

          return (
            <div
              key={img.id}
              className={`slider-card ${img.className}`}
              onClick={() => handleImageClick(index)}
              style={{
                position: 'absolute',
                width: `${cardWidth}px`,
                height: `${cardHeight}px`,
                borderRadius: isMobile ? '16px' : '24px',
                backgroundImage: `url(${img.bg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                transform: transform,
                transition: 'all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                cursor: diff !== 0 ? 'pointer' : 'default',
                zIndex: zIndex,
                opacity: opacity,
                transformStyle: 'preserve-3d',
                overflow: 'hidden',
                willChange: 'transform, opacity'
              }}
            >
              {img.label && (
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  textAlign: 'center',
                  zIndex: 2
                }}>
                  {img.label}
                </div>
              )}

              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '40%',
                pointerEvents: 'none',
                zIndex: 1
              }} />


            </div>
          );
        })}
      </div>

      <div style={{
        position: 'absolute',
        bottom: '-50px',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        gap: '10px',
        display: 'none',
        zIndex: 200
      }}>
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => handleImageClick(index)}
            style={{
              width: currentIndex === index ? '30px' : '10px',
              height: '10px',
              borderRadius: '5px',
              border: 'none',
              background: currentIndex === index 
                ? 'linear-gradient(90deg, #3b82f6, #2563eb)' 
                : 'rgba(255, 255, 255, 0.3)',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: currentIndex === index 
                ? '0 0 10px rgba(59, 130, 246, 0.5)' 
                : 'none'
            }}
          />
        ))}
      </div>
    </div>
  );
};

// ========== AAPKA ORIGINAL TYPING ANIMATION - BILKUL SAME ==========
const TypingAnimation = ({ lines, typingSpeed = 40, lineDelay = 2000 }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [currentLineIndex, setCurrentLineIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isWaiting, setIsWaiting] = useState(false);

  useEffect(() => {
    const currentLine = lines[currentLineIndex];

    if (isWaiting) {
      const timeout = setTimeout(() => {
        setDisplayedText("");
        setCharIndex(0);
        setCurrentLineIndex((currentLineIndex + 1) % lines.length);
        setIsWaiting(false);
      }, lineDelay);
      return () => clearTimeout(timeout);
    }

    if (charIndex < currentLine.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(currentLine.substring(0, charIndex + 1));
        setCharIndex(charIndex + 1);
      }, typingSpeed);
      return () => clearTimeout(timeout);
    } else if (charIndex === currentLine.length) {
      setIsWaiting(true);
    }
  }, [charIndex, currentLineIndex, lines, typingSpeed, lineDelay, isWaiting]);

  return (
    <div className="typing-animation-box">
     <div className="typing-animation-text">
      <div className="typing-line">
        {displayedText}
        {/* <span className="typing-cursor">|</span> */}
      </div>
      <div className="banner-tools-bar">
        <div className="tools-left"><img src={ToolsLeft} className="tools-left-img" />Tools</div>
        <div className="tools-right"><img src={ToolsRight} className="tools-right-img" /></div>
      </div>
      </div>
    </div>
  );
};

// ========== AAPKA ORIGINAL HERO SECTION - BILKUL SAME + SLIDER ADD ==========
const HeroSection = () => {
  const typingLines = [
    "How do I become a robotics engineer?",
    "How do I build my first robot?",
    "How does ROS help in real-time robotics projects?",
    "How can I integrate ML with robotics?"
  ];

  return (
    <div className="herosectioncontainer">
      <Navbar />
      <div className="hero">
        <div className="hero-main-content">
          <div className="hero-banner-text">
            <div className="banner-times-up-bar">
               <div className="banner-times-up-btn">
                 <span className="times-up-active">Industrial Training</span>
                 <span className="program-btn">Program</span>
               </div>
            </div>
            <div className="hero-left-bar">
              <div className="banner-title-bar">
                <div className="banner-title-top01">
                  <h2>Step Into The Future Of</h2>
                </div>
                <div className="banner-title-top01 title-top02">
                 <h2><span>Robotics & AI</span> With <img src={BannerLogo} className="banner-logo" /></h2>
                </div> 
              </div>
              {/* <div className="banner-left-img">
                <img src={herotext} className="herosection__image-text" />
              </div> */}
              <TypingAnimation lines={typingLines} />
              <div className="herosection__bottom">
                <div className="herosection__btns">
                  <a href="#ask-id" className="hero__enroll-btn learn-more">
                  Get in Contact
                  </a>
                  <a href="#ask-id" className="banner-brochure-btn">Brochure</a>
                  <div className="brochure-download"><img src={BrochureDownload} className="brochure-download-img" /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <ImageSlider />
      </div>
    </div>
  );
};

export default HeroSection;